module.exports = __webpack_public_path__ + "static/media/pl_preview.97a88b9e.jpg";